/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber24Small = createReactComponent("number-24-small", "IconNumber24Small", [
  ["path", { d: "M14 8v3a1 1 0 0 0 1 1h3", key: "svg-0" }],
  ["path", { d: "M18 8v8", key: "svg-1" }],
  [
    "path",
    {
      d: "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3",
      key: "svg-2"
    }
  ]
]);

export { IconNumber24Small as default };
//# sourceMappingURL=IconNumber24Small.js.map
